export const ExpenseFormDefaultValues = {
  incomplete: false,
  date: '',
  analyst: '',
  jobOrder: '',
  miscDescription: '',
};
